import { useState, useEffect } from 'react';
import CrudList from "./crud/CrudList";
import Form from 'react-bootstrap/Form';
import { callApi, ErrorAlert } from './crud/utils';
import useApp from './AppContext';

function ObjectBrowser(props) {
    const app = useApp();
    const [error, setError] = useState(null);
    const [serverUrl] = useState(app.serverUrl);
    const [layouts, setLayouts] = useState(null);
    const [selectedLayoutIndex, setSelectedLayoutIndex] = useState(-1);
    const language = app.sessionToken?.Language;
    useEffect(() => {
        async function getLayouts() {
            try {
                if (!serverUrl) return;
                setLayouts(await callApi('GET', `${serverUrl}/api/layouts`), "");
            } catch (err) {
                setError(err.message);
            }
        };
        getLayouts();
    }, [props.layoutUrl, props.userToken, serverUrl]);

    function createLayoutList() {
        if (!layouts) return;
        return (
            <Form.Control
                as="select"
                value={selectedLayoutIndex}
                onChange={e => {
                    setSelectedLayoutIndex(e.target.selectedIndex)
                }}
            >
                {layouts.map((layout, i) =>
                    <option key={i} value={i}>{layout.caption}</option>
                )}
            </Form.Control>
        )
    }

    function createCrudList() {
        if (selectedLayoutIndex < 0) return;
        return <CrudList userToken="" layoutUrl={`api/layouts/list/${layouts[selectedLayoutIndex].layoutId}`} />
    }

    return (
        <>
            <ErrorAlert message={error} setMessage={setError} language={language} />
            {createLayoutList()}
            {createCrudList()}
        </>
    );
}

export default ObjectBrowser;